// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles_buttonWrapper__3U1oZ","link":"styles_link__20-eJ"};